/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSouscriptionCompanyQuery = gql`
  query GetSouscriptionCompanyQuery {
    getSouscriptionCompany_souscription_company {
      decisionMakerContact {
 switch  
firstName  
lastName  
emails {
 value  
} 
phones {
 internationalCode  
number  
isMobile  
} 
}
      hrContact {
 switch  
firstName  
lastName  
emails {
 value  
} 
phones {
 internationalCode  
number  
isMobile  
} 
}
    }
  }
`;

export default GetSouscriptionCompanyQuery;
